import { useBillingInfo } from './useBillingInfo';

/**
 * May this viewer BUY a plan through Clerk's own account Billing tab?
 *
 * Not once checkout is Stripe's (server flag, reported on the billing info as
 * `checkoutProvider`). That tab is a second door into Clerk's checkout drawer
 * ("Switch plans" / "Subscribe"); left open, an owner could still buy the old
 * way and land the team on the biller the flag was flipped to leave.
 *
 * True while billing info is loading or the server predates the field, so the
 * pre-2026-09-18 behaviour is the default and nothing flickers shut.
 */
export function useClerkPurchaseEnabled(): boolean {
  const { data } = useBillingInfo();
  return data?.checkoutProvider !== 'stripe';
}
